<style lang="scss">
.account-detail .ivu-select-disabled {
  .ivu-tag-checked {
    cursor: default;
    border: none;
    background-color: transparent;
  }
  .ivu-icon-ios-close-empty {
    display: none;
  }
}
.account-detail .ivu-form-item {
  margin-bottom: 12px;
}
</style>
<template>
    <div class="lookinfo bg-fff account-detail">
         <Form :label-width="160">
            <compWrapper :title="$t('global.common.base_information', { defaultValue: '基本信息' })" theme="primary">
                <FormItem :label="`${$t('erp.channelbase.channel_type', { defaultValue: '渠道类型' })}：`">
                    <span>{{otherData.channelCategoryId|transferText('name',accountTypes)}}</span>
                </FormItem>
                <FormItem :label="`${$t('erp.channelbase.channel_name', { defaultValue: '渠道名称' })}：`">
                    <span>{{otherData.accountName}}</span>
                </FormItem>
                <template  v-for="item in formData">
                    <FormItem :label="`${$t('erp.channel.warehouse_sign', { defaultValue: '渠道仓库标识符' })}：`">
                        <span>{{item.addressCode}}</span>
                    </FormItem>
                    <FormItem  :label="`${$t('erp.b2c.product_orgwarehouse', { defaultValue: '仓库' })}：`">
                        <Select :value="item.orgWarehouseIds" multiple disabled>
                            <Option v-for="item in warehouses" :value="item.value" :key="item.value" :disabled='item.disabled'>{{ item.label }}</Option>
                        </Select>
                    </FormItem>
                </template>
            </compWrapper>
            <compWrapper :title="$t('global.common.operation_history', { defaultValue: '操作历史' })" theme="gray">
                <compLog :columns="logcolumns" :data="logList"></compLog>
            </compWrapper>
            <footer class="text-right">
                <Button @click="cancel">{{$t('global.common.return', { defaultValue: '返回' })}}</Button>
            </footer>
        </Form>
        <Spin size="large" fix v-if="loading"></Spin>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { HttpUpdateWhAccount, HttpWhAccount, HttpAccountType, HttpSysOpLogNew } from '@/service/boss/allot';

export default {
    props: ['id'],
    components: {
        compLog: () => import("@components/templates/log"),
    },
    data() {
        return {
            loading: false,
            accountTypes: [],
            otherData: {
                accountName: '',
                channelCategoryId: ''
            },
            formData: [{
                addressCode: '',
                orgWarehouseIds: '',
            }],
            logList: []
        }
    },
    created() {
        this.gtAccountTypes();
        this.getDetail();
        this.getLog()
    },

    computed: {
        // ...mapState('boss',['accounts']),
        // ...mapGetters('boss',['warehouses']),
        ...mapGetters('diction',['getNewAccountIdList','getNewWarehouseIdList']),
        warehouses(){
            return this.getNewWarehouseIdList.filter(item => {
                return item.attach.item.warehouseType !== 2 && item.attach.item.warehouseType !== 4;
            });
        },
        logcolumns () {
            return [{
                title: this.$t('erp.channel.change_people', { defaultValue: '修改人' }),
                key: 'createdName',
                width: 55,
                align: 'center'
            }, {
                title: this.$t('erp.channel.change_time', { defaultValue: '修改时间' }),
                key: 'createdAt',
                width: 130
            }, {
                title: this.$t('global.common.reason', { defaultValue: '原因' }),
                key: 'opRemark'
            }]
        }
    },
    methods: {
        getLog () {
            HttpSysOpLogNew({
                    page: 1,
                    rows: 10,
                    sidx: 'id',
                    sord: 'desc',
                    'search[EQ_systemId]':this.id,
                    'search[EQ_opModel]':'StockAccountAddress',
                }).then(res=>{
                    this.logList = res.data.content
                },err=>{
                    this.errorMessage(err.message);
                })
        },
        cancel() {
            this.$emit('on-close');
        },
        handleDResponse(data) {
            const firstItem = data[0];
            if (!firstItem) return;
            this.formData = data.map((item) => {
                return {
                    addressCode: item.addressCode,
                    orgWarehouseIds: item.items.map((json) => {
                        return json.orgWarehouseId;
                    })
                };
            });
            this.otherData.channelCategoryId = firstItem.channelCategoryId;
            this.otherData.accountName = firstItem.accountFlag;
        },
        async gtAccountTypes() {
            HttpAccountType().then(res => {
                this.accountTypes = res.data;
            })
        },
        async getDetail() {
            this.loading = true;
            HttpWhAccount({ accountId: this.id }).then(res => {
                this.handleDResponse(res.data);
                 this.loading = false;
            }, err => {
                this.$VMessage.error({
                content: err.message,
                duration: 30,
                closable: true
                });
                 this.loading = false;
            })
        },

    }
}
</script>

